require("intersection-observer");

import { LuminousGallery } from "luminous-lightbox";
import { lock, unlock } from "tua-body-scroll-lock";

export default {
  methods: {
    // ギャラリー表示用メソッド
    luminousOpen: function() {
      lock();
    },
    luminousClose: function() {
      unlock();
    },
    startUpLuminous: function(_targets) {
      const luminousOptions = {
        onOpen: this.luminousOpen,
        onClose: this.luminousClose
      };
      const galleryOptions = {
        arrowNavigation: true
      };
      return new LuminousGallery(_targets, galleryOptions, luminousOptions);
    },
    // lazyload用メソッド
    addShowClass: function(entries) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("is-show");
        }
      });
    },
    onIntersection: function(target, options = {}) {
      const observer = new IntersectionObserver(this.addShowClass, options);
      observer.observe(target);
    },
    startUpLazyLoad: function(_targets) {
      const options = {
        root: null,
        rootMargin: "0px",
        threshold: 0
      };
      for (let i = 0; i < _targets.length; i++) {
        setTimeout(() => {
          this.onIntersection(_targets[i], options);
        }, 150 * i);
      }
    }
  }
};
